export default "/images/ocr-logo.png";